require './image-management'
require './delete-image-modal'
require './upload-image-modal'
require './edit-details'
require './analysis'
require './upload-new-image-setup'
